module.exports = __webpack_public_path__ + "static/media/Glyph_Large_Help.b327a9ad.png";